import styled from 'styled-components'
import layout from '../../tokens/v2/layout'

export const Wrapper = styled.div`
  display: flex;

  input {
    border-top-left-radius: ${layout.spacing.none};
    border-bottom-left-radius: ${layout.spacing.none};
  }
`
